import { useTour } from '@reactour/tour'
import {
  ArrowAllCalendars,
  ContactUs,
  GuidedTourIcon,
  MenuUserGuideIcon
} from 'assets/icons'
import {
  ONBOARDING_MODE,
  useTfmTourProvider
} from 'components/onboarding/TFMTourProvider'
import PopupSection from 'components/popup/PopupSection'
import PopupSectionRow from 'components/popup/PopupSectionRow'
import i18n from 'i18n'
import { t } from 'i18next'
import { useState } from 'react'
import LocalStorage from 'services/LocalStorage'
import { LocalStorageKey } from 'types/services/localStorage'
import { is24meApp, isGroupcalApp } from 'utils/appType'
import ContactUsPopup from './ContactUsPopup'

export interface HelpCenterSectionProps {
  setPopupOpen: (b: boolean) => void
}

export default function HelpCenterSection(props: HelpCenterSectionProps) {
  const [showContactUs, setShowContactUs] = useState(false)
  const onContactUs = () => {
    setShowContactUs(true)
  }

  const { isOpen, currentStep, steps, setIsOpen, setCurrentStep, setSteps } =
    useTour()

  const tfmTour = useTfmTourProvider()

  const onGuidedTour = () => {
    LocalStorage.set(LocalStorageKey.USER_FINSHED_ONBOARDING, '0')
    LocalStorage.remove(LocalStorageKey.STATE_DICT)

    tfmTour.setMode(ONBOARDING_MODE.FIRST_LOGIN)
    tfmTour.reset()

    if (setSteps && tfmTour.getStepsByMode) {
      setSteps(tfmTour.getStepsByMode(ONBOARDING_MODE.FIRST_LOGIN))
    }
    setCurrentStep(0)
    setIsOpen(true)

    props.setPopupOpen(false)
  }

  return (
    <PopupSection title={`${t('helpCenter')}`} popupSectionGap={1}>
      {isGroupcalApp() && (
        <PopupSectionRow
          actionId="guided-tour-button"
          icon={<GuidedTourIcon />}
          title={t('guidedTour')}
          iconClass="icon-regular"
          maxWidthIcon={20}
          onlyTitle
          actionBg
          engulfEntireRow
          action={onGuidedTour}
        />
      )}
      <ContactUsPopup
        open={showContactUs}
        setOpen={function (b: boolean): void {
          setShowContactUs(b)
        }}
        setMenuOpen={props.setPopupOpen}
      >
        <span>
          <PopupSectionRow
            icon={<ContactUs />}
            title={t('contactUs')}
            iconClass="icon-regular"
            maxWidthIcon={20}
            action={onContactUs}
            actionBg
            engulfEntireRow
            value={
              <ArrowAllCalendars
                style={{
                  transform: i18n.dir() === 'ltr' ? '' : 'rotate(180deg)',
                  cursor: 'pointer',
                  marginTop: 4
                }}
              />
            }
          />
        </span>
      </ContactUsPopup>
      <PopupSectionRow
        title={t('userGuide')}
        icon={<MenuUserGuideIcon />}
        iconClass="icon-regular"
        maxWidthIcon={20}
        actionBg
        engulfEntireRow
        action={() => {
          window.open(
            is24meApp()
              ? 'https://24me.zendesk.com/'
              : 'https://www.groupcal.app/guide/',
            '_blank'
          )
        }}
      />
    </PopupSection>
  )
}
